document.addEventListener('DOMContentLoaded', () => {
    const capsuleSliderTop = document.querySelector('.capsule-slider-top ');
    if (capsuleSliderTop) {
        new Swiper(capsuleSliderTop, {
            loop: true,
            centeredSlides: true,
            slidesPerView: 2,
            spaceBetwee: 30,
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              768: {
                slidesPerView: 3,
                spaceBetwee: 300,
              }
            }
        });
    }

    const capsuleSliderBottom = document.querySelector('.capsule-slider-bottom ');
    if (capsuleSliderBottom) {
        new Swiper(capsuleSliderBottom, {
            loop: true,
            centeredSlides: true,
            slidesPerView: 2,
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
             breakpoints: {
              768: {
                slidesPerView: 3
              }
            }
        });
    }

    const meetSlider = document.querySelector('.meet-section-slider');

    if (meetSlider) {
        const slidesCount = meetSlider.querySelectorAll('.swiper-slide').length;

        if (slidesCount > 1) {
            // Инициализируем Swiper только если слайдов больше 1
            new Swiper(meetSlider, {
                loop: true,
                spaceBetween: 20,
                centeredSlides: true,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: { slidesPerView: 1.3 },
                    768: { slidesPerView: 2.3 },
                    1024: { slidesPerView: 1 }
                },
                on: {
                    slideChange: function () {
                        const activeSlide = this.slides[this.activeIndex];
                        const activeId = activeSlide.getAttribute('id');

                        document.querySelectorAll('.meet-section-gallery-image img').forEach((img) => {
                            img.classList.toggle('active', img.dataset.id === activeId);
                        });
                    },
                },
            });
        }
    }


    const oldLink = document.querySelector('.button--AZy9VblJnSU9BZnBJT__button_nBrcHj');

    if (oldLink && oldLink.tagName === 'A') {
      const href = oldLink.getAttribute('href');
      const button = document.createElement('button');
    
      // Скопировать классы и контент
      button.className = oldLink.className;
      button.innerHTML = oldLink.innerHTML;
      button.style.maxWidth = "fit-content";
    
      // Перенести href в data-href
      button.setAttribute('data-href', href);
    
      // Заменить <a> на <button>
      oldLink.replaceWith(button);
    
      // Назначить обработчик клика
      button.addEventListener('click', () => {
        const topSlide = document.querySelector('.capsule-slider-top .swiper-slide-active');
        const bottomSlide = document.querySelector('.capsule-slider-bottom .swiper-slide-active');
    
        if (!topSlide || !bottomSlide) {
          console.warn('❌ Один из слайдов не найден');
          return;
        }
    
        const capsuleData = {
          top: {
            id: topSlide.dataset.id,
            img: topSlide.querySelector('img').src,
            collection: topSlide.dataset.collection,
            price: topSlide.dataset.price
          },
          bottom: {
            id: bottomSlide.dataset.id,
            img: bottomSlide.querySelector('img').src,
            collection: bottomSlide.dataset.collection,
            price: bottomSlide.dataset.price
          }
        };
    
        if (!capsuleData.top.id || !capsuleData.bottom.id) {
          console.warn('❌ Не удалось определить ID товаров');
          return;
        }

        console.log(JSON.stringify(capsuleData));
    
        localStorage.setItem('capsuleSelection', JSON.stringify(capsuleData));
    
        // Переход на сохранённый href
        const targetHref = button.getAttribute('data-href');
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (targetHref) {
              window.location.href = targetHref;
            }
          }, 300);
        });
      });
    }
});